(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('contenteditable', [
    '$sce', function($sce) {
      return {
        restrict: 'A',
        require: '?ngModel',
        link: (function(_this) {
          return function(scope, element, attrs, ngModel) {
            var read;
            if (!ngModel) {
              return;
            }
            ngModel.$render = function() {
              element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              return element.find('a').each(function(i, elem) {
                elem.contentEditable = 'false';
                return elem.target = '_blank';
              });
            };
            read = function() {
              var html;
              html = element.html();
              if (attrs.stripBr && html === '<br>') {
                html = '';
              }
              return ngModel.$setViewValue(html);
            };
            return element.on('blur keyup change', function() {
              return scope.$evalAsync(read);
            });
          };
        })(this)
      };
    }
  ]);

}).call(this);
